export default {
  konbiniEmail: {
    id: 'merchant_options_payment_konbini_settings_modal_email',
    defaultMessage: 'Email address',
  },
  konbiniInfoBlockContent: {
    id: 'merchant_options_payment_konbini_settings_modal_info_block_text',
    defaultMessage:
      'Know that this information will be visible to your customers.',
  },
  konbiniPhoneNumber: {
    id: 'merchant_options_payment_konbini_settings_modal_phone_number',
    defaultMessage: 'Phone number',
  },
  konbiniSettingsUpdateSuccessMessage: {
    id: 'merchant_options_payment_konbini_settings_modal_update_success_message',
    defaultMessage: 'Konbini payment settings have been correctly updated.',
  },
  loading: {
    id: 'merchant_options_payment_konbini_settings_modal_loading',
    defaultMessage: 'Loading...',
  },
  required: {
    id: 'merchant_options_payment_konbini_settings_modal_required',
    defaultMessage: 'This field is required',
  },
  emailInvalid: {
    id: 'merchant_options_payment_konbini_settings_modal_email_invalid',
    defaultMessage: 'This email is invalid',
  },
  save: {
    id: 'merchant_options_payment_konbini_settings_modal_submit_button_label',
    defaultMessage: 'Set up',
  },
  storeOperationManager: {
    id: 'merchant_options_payment_konbini_settings_modal_operation_manager',
    defaultMessage: 'Business operation manager',
  },
  storeSecurityOfficer: {
    id: 'merchant_options_payment_konbini_settings_modal_security_officer',
    defaultMessage: 'Business security officer',
  },
  subtitle: {
    id: 'merchant_options_payment_konbini_settings_modal_subtitle',
    defaultMessage: 'Fill out these details to offer Konbini payment.',
  },
  title: {
    id: 'merchant_options_payment_konbini_settings_modal_title',
    defaultMessage: 'Set up Konbini',
  },
  close: {
    id: 'merchant_options_payment_konbini_settings_modal_close',
    defaultMessage: 'Close',
  },
  inputClear: {
    id: 'merchant_options_payment_konbini_settings_modal_input_clear',
    defaultMessage: 'Clear',
  },
}
